import { createApp } from 'vue'
import App from './App.vue'
import router from "./router";
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as labsComponents from 'vuetify/labs/components'
import * as directives from 'vuetify/directives'
import './assets/styles/global.css';
import './assets/styles/liquid-nature.css';

import "@mdi/font/css/materialdesignicons.css";

// i18n
import { createI18n } from 'vue-i18n'
import fr from './locales/fr.json'
import en from './locales/en.json'

const vuetify = createVuetify({
    components: {
        ...components,
        ...labsComponents,
    },
    directives,
})
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const i18n = createI18n({
    legacy: false,
    locale: 'fr',
    fallbackLocale: 'en',
    messages: {
        fr,
        en
    }
})

createApp(App).use(router).use(pinia).use(vuetify).use(i18n).mount('#app')
